import Vue from 'vue'
import Router from 'vue-router'

import events from '../services/events'

Vue.use(Router)

const router = new Router({
	mode: 'history',
  saveScrollPosition: true,
	base: '/',
  routes: [
		{
			path: '/stylebook',
			name: 'Stylebook',
			component: () => import(/* webpackChunkName: "Stylebook" */ '../pages/Stylebook.vue'),
      meta: {
        auth: false
      }
		},

    /* ------ Homepage ------ */
		{
			path: '/',
			name: 'Home',
			component: () => import(/* webpackChunkName: "Home" */ '../components/homepage-get-quote.vue'),
		},
    {
      path: '/logout',
      name: 'Logout',
      component: () => import(/* webpackChunkName: "Logout" */ '../components/logout.vue'),
      alias: [
        '/users/logout'
      ],
    },
		{
			path: '/product',
			name: 'HomepageProduct',
			component: () => import(/* webpackChunkName: "HomepageProduct" */ '../components/homepage/homepage-product.vue'),
		},
		{
			path: '/bett',
			name: 'HomepageBett',
			component: () => import(/* webpackChunkName: "HomepageBett" */ '../components/homepage/homepage-bett.vue'),
		},
		{
			path: '/questions',
			name: 'HomepageQuestions',
			component: () => import(/* webpackChunkName: "HomepageQuestions" */ '../components/homepage/homepage-questions.vue'),
		},
		{
			path: '/about',
			name: 'HomepageAbout',
			component: () => import(/* webpackChunkName: "HomepageAbout" */ '../components/homepage/homepage-about.vue'),
		},
		{
			path: '/jobs',
			name: 'HomepageJobs',
			component: () => import(/* webpackChunkName: "HomepageJobs" */ '../components/homepage/homepage-jobs.vue'),
    },
    {
      path: '/terms/:language?',
      name: 'Terms',
      component: () => import(/* webpackChunkName: "Terms" */ '../pages/GeneralTerms.vue'),
    },
    {
      path: '/short-terms',
      name: 'Short terms',
      component: () => import(/* webpackChunkName: "Short Terms" */ '../pages/Terms.vue'),
      meta: {
        auth: true
      }
    },
		{
      path: '/closed',
      name: 'Closed',
      component: () => import(/* webpackChunkName: "Closed" */ '../pages/Closed.vue'),
    },

    /* ------ Logged out ------ */
    {
      path: '/users/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "Login" */ '../pages/Login.vue'),
    },
    {
      path: '/users/forgot-password',
      name: 'ForgotPassword',
      component: () => import(/* webpackChunkName: "ForgotPassword" */ '../pages/ForgotPassword.vue'),
    },
    {
      path: '/users/create-password',
      name: 'CreatePassword',
      props: { new_user: true},
      component: () => import(/* webpackChunkName: "ForgotPassword" */ '../pages/ForgotPassword.vue'),
    },
    {
      path: '/users/reset-password',
      name: 'ResetPassword',
      component: () => import(/* webpackChunkName: "ResetPassword" */ '../pages/ResetPassword.vue'),
    },
    {
      path: '/users/change-email',
      name: 'ChangeEmail',
      component: () => import(/* webpackChunkName: "ChangeEmail" */ '../pages/ChangeEmail.vue')
    },

    /* ------ Logged in ------ */
    {
      path: '/school/admin/dashboard',
      name: 'DashboardSchoolAdmin',
      component: () => import(/* webpackChunkName: "DashboardSchoolAdmin" */ '../pages/dashboard/SchoolAdmin.vue'),
      meta: {
        auth: true
      }
    },

    /* ------ Survey Wizard ------ */
    {
      path: '/survey/create',
      name: 'SurveyCreate',
      component: () => import(/* webpackChunkName: "SurveyCreate" */ '../pages/SurveyCreate.vue'),
      meta: {
        auth: true
      },
    },
    {
      path: '/survey/wizard',
      name: 'SurveyWizard',
      component: () => import(/* webpackChunkName: "SurveyWizard" */ '../pages/SurveyWizard.vue'),
      meta: {
        auth: true
      },
			children: [
				{
		      path: '/survey/wizard/:id',
				},
			],
    },

    /* ------ Metrics Overview ------ */
    {
      path: '/metrics',
      name: 'MetricsOverview',
      component: () => import(/* webpackChunkName: "MetricsOverview" */ '../pages/MetricsOverview.vue'),
      meta: {
        auth: true
      },
    },

    /* ------ Identity switcher ------ */
    {
      path: '/users/identity',
      name: 'IdentitySwitcher',
      component: () => import(/* webpackChunkName: "IdentitySwitcher" */ '../pages/IdentitySwitcher.vue'),
      meta: {
        auth: true
      }
    },

    /* ------ Unbecome, Back to Superadmin ------ */
    {
      path: '/users/unbecome',
      name: 'UnbecomeLoading',
      component: () => import(/* webpackChunkName: "UnbecomeLoading" */ '../components/custom/unbecome-loading.vue'),
      meta: {
        auth: true
      }
    },

    /* ------ Results ------ */
    {
      path: '/school/results',
      name: 'ResultsIndex',
      component: () => import(/* webpackChunkName: "ResultsIndex" */ '../pages/results/Index.vue'),
      meta: {
        auth: true,
        permissions: ['view_survey_results']
      },
			alias: [
				'/school/teacher/results-dashboard'
			],
    },
    {
        path: '/school/action-plans/:id?',
        name: 'ActionPlans',
        component: () => import(/* webpackChunkName: "ActionPlans" */ '../pages/dashboard/action-plans/ActionPlansList.vue'),
        meta: {
            auth: true
        }
    },

    // https://gitlab.com/edurio/wiki/issues/4537
    // Currently rerouted to organization results page
    {
      path: '/v2/school/teacher/results/:id',
      name: 'ResultsDashboard',
      component: () => import(/* webpackChunkName: "ResultsDashboard" */ '../pages/organization/ResultsV2.vue'),
      meta: {
        auth: true,
        permissions: ['view_survey_results']
      },
			alias: [
				'/v2/school/results/:id'
			],
      children: [
        {
          path: ':compare',
          component: () => import(/* webpackChunkName: "ResultsDashboard" */ '../pages/organization/ResultsV2.vue'),
          meta: {
            auth: true,
            permissions: ['view_survey_results']
          },
        }
      ]
    },


    // Surveys
      {
          path: '/survey-builder/:version/:uuid',
          name: 'Survey Builder v1',
          redirect: '/survey-builder/:uuid'
      },
      {
          path: '/survey-builder/:uuid',
          name: 'Survey Builder',
          component: () => import(/* webpackChunkName: "Survey Builder" */ '../pages/survey-builder/SurveyBuilder.vue'),
          meta: {
              title: 'Survey Builder - Edurio',
              auth: false
          },
      },
      {
          path: '/self-assessment',
          name: 'Self Assessment Survey',
          component: () => import(/* webpackChunkName: "Self Assessment Survey" */ '../pages/self-assessment/Landing.vue'),
          meta: {
              title: 'Self Assessment - Edurio',
              auth: false
          },
      },
      {
          path: '/self-assessment/results/:id',
          name: 'Self Assessment Survey Results',
          component: () => import(/* webpackChunkName: "Self Assessment Survey Results" */ '../pages/self-assessment/Results.vue'),
          meta: {
              title: 'Self Assessment Results - Edurio',
              auth: false
          },
      },

    // Users
    {
      path: '/school/users',
      name: 'RespondentsIndex',
      component: () => import(/* webpackChunkName: "RespondentsIndex" */ '../pages/respondents/Index.vue'),
      meta: {
        auth: true,
        permissions: ['manage_respondents', 'view_respondents', 'manage_admins']
      }
    },

		{
			path: '/school/admin/school-management',
			redirect: '/school/users'
		},

    {
      path: '/school/classes',
      name: 'RespondentsClasses',
      component: () => import(/* webpackChunkName: "RespondentsClasses" */ '../pages/respondents/Classes/Classes.vue'),
      meta: {
        auth: true,
        permissions: ['view_respondents', 'manage_respondents']
      }
    },

    {
      path: '/school/classes/list',
      name: 'classListPage',
      component: () => import(/* webpackChunkName: "RespondentsClasses" */ '../pages/respondents/Classes/List.vue'),
      meta: {
        auth: true,
        permissions: ['view_respondents', 'manage_respondents']
      }
    },

    {
      path: '/school/classes/:id',
      name: 'classShowPage',
      component: () => import(/* webpackChunkName: "RespondentsClasses" */ '../pages/respondents/Classes/Show.vue'),
      meta: {
        auth: true,
        permissions: ['view_respondents', 'manage_respondents']
      }
    },
    {
      path: '/school/eu-groups',
      name: 'EUGroups',
      component: () => import(/* webpackChunkName: "RespondentsGroups" */ '../pages/respondents/EUGroups.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/school/groups',
      name: 'RespondentsGroups',
      component: () => import(/* webpackChunkName: "RespondentsGroups" */ '../pages/respondents/Groups.vue'),
      meta: {
        auth: true,
        permissions: ['view_respondents', 'manage_respondents'],
        forbiddenProducts: ['disable_users_section']
      }
    },
    {
      path: '/school/year-wizard',
      name: 'YearWizard',
      redirect: '/school/import-types',
    },
    {
      path: '/school/import-types',
      name: 'ImportTypes',
      component: () => import(/* webpackChunkName: "ImportTypes" */ '../pages/SchoolDataImport/ImportTypes.vue'),
      meta: {
        auth: true,
        permissions: ['manage_respondents']
      }
    },
    {
      path: '/school/import/:type/:section?',
      name: 'ImportTypes',
      component: () => import(/* webpackChunkName: "Index" */ '../pages/SchoolDataImport/Index.vue'),
      meta: {
        auth: true,
        permissions: ['manage_respondents']
      }
    },
    {
      path: '/school/prerequisites-error',
      name: 'PrerequisitesError',
      component: () => import(/* webpackChunkName: "PrerequisitesError" */ '../pages/SchoolDataImport/PrerequisitesError.vue'),
      meta: {
        auth: true,
        permissions: ['manage_respondents']
      }
    },
		{
      path: '/school/sso',
      name: 'SSOManagement',
      component: () => import(/* webpackChunkName: "SSOManagement" */ '../pages/dashboard/SSOManagement.vue'),
      meta: {
        auth: true,
        permissions: ['manage_respondents']
      }
    },
    {
      path: '/client-data-upload/:id?',
      name: 'ClientDataUpload',
      component: () => import(/* webpackChunkName: "ClientDataUpload" */ '../pages/ClientDataUpload/Index.vue'),
      meta: {
        auth: true,
        permissions: ['manage_respondents']
      }
    },

    /* ------ Students ------ */
    {
      path: '/student/dashboard',
      name: 'StudentDashboard',
      component: () => import(/* webpackChunkName: "StudentDashboard" */ '../pages/student/Dashboard.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/student/poll/:poll_id/:identity_id',
      name: 'StudentPoll',
      component: () => import(/* webpackChunkName: "StudentPoll" */ '../pages/student/Poll.vue'),
      meta: {
        auth: true
      }
    },

    /* ------ Teachers ------ */
    {
      path: '/teacher/poll/:poll_url',
      name: 'TeacherPoll',
      component: () => import(/* webpackChunkName: "TeacherPoll" */ '../pages/teacher/Poll.vue')
    },
    {
      path: '/school/teacher/dashboard',
      name: 'TeacherDashboard',
      component: () => import(/* webpackChunkName: "TeacherDashboard" */ '../pages/teacher/Dashboard.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/school/teacher/poll/:poll_id/:identity_id',
      name: 'SchoolTeacherPoll',
      component: () => import(/* webpackChunkName: "SchoolTeacherPoll" */ '../pages/teacher/SchoolTeacherPoll.vue'),
      meta: {
        auth: true
      }
    },

    /* ------ Preview ------ */
    {
      path: '/school/preview/survey/:poll_id',
      name: 'PreviewPoll',
      component: () => import(/* webpackChunkName: "PreviewPoll" */ '../pages/preview/Poll.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/preview/survey/:slug',
      name: 'PreviewPollSchool',
      component: () => import(/* webpackChunkName: "PreviewPollSchool" */ '../pages/preview/Poll.vue')
    },

    /* ------ Organizations ------ */
    {
      path: '/organization/dashboard',
      name: 'OrgnizationDashboard',
      component: () => import(/* webpackChunkName: "OrgnizationDashboard" */ '../pages/organization/Dashboard.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/organization/results',
      name: 'OrgnizationResultsIndex',
      component: () => import(/* webpackChunkName: "OrgnizationResultsIndex" */ '../pages/organization/ResultsIndex.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/v2/organization/results/open/:type/:id',
      name: 'OrgnizationResultsV2',
      component: () => import(/* webpackChunkName: "OrgnizationResultsV2" */ '../pages/organization/ResultsV2.vue'),
      meta: {
        auth: true
      },
      children: [
        {
          path: ':compare',
          component: () => import(/* webpackChunkName: "OrgnizationResultsV2" */ '../pages/organization/ResultsV2.vue'),
          meta: {
              auth: true
          },
        },
      ],
    },

    /* ------ Special custom urls ------ */
    {
      path: '/skola2030',
      name: 'Skola2030',
      component: () => import(/* webpackChunkName: "Skola2030" */ '../pages/custom/Skola2030.vue'),
    },
    {
      path: '/users/about',
      name: 'UsersAbout',
      component: () => import(/* webpackChunkName: "UsersAbout" */ '../pages/users/About.vue'),
    },

    /* ------ Superadmin ------ */
    {
      path: '/admin/super-admins',
      name: 'SuperAdminSuperadminList',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/superadmin/index.vue'),
      meta: {
        auth: true,
        title: 'Super-admins - Edurio'
      }
    },
    {
      path: '/admin/super-admin/:id',
      name: 'SuperAdminSectionPermissions',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/superadmin/section-permissions.vue'),
      meta: {
        auth: true,
        title: 'Edit super-admin - Edurio'
      }
    },
    {
      path: '/survey/surveys',
      name: 'super-admin-survey-periods',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey-period/survey-periods.vue'),
      meta: {
        auth: true,
        title: 'Survey templates - Edurio'
      }
    },
    {
      path: '/survey/search-surveys',
      name: 'super-admin-search-surveys',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey/search.vue'),
      meta: {
        auth: true,
        title: 'Survey templates - Edurio'
      }
    },
    {
      path: '/survey/survey-period-search',
      name: 'super-admin-search-surveys',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey/survey-period-search.vue'),
      meta: {
        auth: true,
        title: 'Survey Period Search - Edurio'
      }
    },
    {
      path: '/survey/create-poll',
      redirect: '/super-admin/surveys/create',
    },
    {
      path: '/admin/survey-periods/:survey_id',
      name: 'survey-periods-table',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey-periods-table.vue'),
      meta: {
        auth: true,
        title: 'Survey periods for survey - Edurio'
      },
      children: [
        {
          path: ':parent_org_id',
					component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey-periods-table.vue'),
        }
      ]
    },
    {
      path: '/admin/schools',
      name: 'school-admin-schools',
      component: () => import(/* webpackChunkName: "school-admin-schools" */ '../components/school-admin/schools.vue'),
      meta: {
        auth: true,
        title: 'School and Solo accounts - Edurio'
      }
    },
    // #3816 Load the '/admin/users' view.
    {
      path: '/admin/users',
      name: 'superadmin-users',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/users/index.vue'),
      meta: {
        auth: true,
        title: 'Users - Edurio'
      }
    },
    {
      path: '/admin/delete-respondents',
      name: 'super-admin-delete-respondents',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/users/delete-respondents.vue'),
      meta: {
        auth: true,
        title: 'Delete respondents - Edurio'
      }
    },
    {
      path: '/admin/subjects/:id',
      name: 'super-admin-subject-list',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/subject/index.vue'),
      meta: {
        auth: true,
        title: 'Organization subjects - Edurio'
      }
    },
    {
      path: '/admin/add-subjects/:id',
      name: 'super-admin-subject-create',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/subject/create.vue'),
      meta: {
        auth: true,
        title: 'Add subjects to organization - Edurio'
      }
    },
    {
      path: '/admin/classes/:id',
      name: 'super-admin-class-list',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/class/index.vue'),
      meta: {
        auth: true,
        title: 'Organization classes - Edurio'
      }
    },
    {
      path: '/admin/add-classes/:id',
      name: 'super-admin-class-create',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/class/create.vue'),
      meta: {
        auth: true,
        title: 'Add classes to organization - Edurio'
      }
    },
    {
      path: '/admin/organization-tags/:id',
      name: 'school-admin-add-tags',
      component: () => import(/* webpackChunkName: "school-admin-add-tags" */ '../components/school-admin/addtags.vue'),
      meta: {
        auth: true,
        title: 'Organization tags - Edurio'
      }
    },
    {
      path: '/admin/organization-properties/:id',
      name: 'organization-properties',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/properties/organization-properties.vue'),
      meta: {
        auth: true,
        title: 'Organization properties - Edurio'
      }
    },
    {
      path: '/admin/organization-property-values/:id',
      name: 'organization-property-values',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/properties/organization-property-values.vue'),
      meta: {
        auth: true,
        title: 'Property values - Edurio'
      }
    },
    {
      path: '/admin/organization-property-value-users/:id',
      name: 'organization-property-value-users',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/properties/organization-property-value-users.vue'),
      meta: {
        auth: true,
        title: 'Users for property value - Edurio'
      }
    },
    {
      path: '/admin/organizations',
      name: 'organization-admin-organizations',
      component: () => import(/* webpackChunkName: "organization-admin-organizations" */ '../components/organization-admin/organizations.vue'),
      meta: {
        auth: true,
        title: 'All organizations - Edurio'
      }
    },
    {
      path: '/admin/school/:id',
      name: 'super-admin-organization-permissions',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/superadmin/organization-permissions.vue'),
      meta: {
        auth: true,
        title: 'Organization permissions - Edurio'
      }
    },
    {
      path: '/admin/organization/:id/:tab?',
      name: 'SuperAdminOrganizationShow',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../pages/superadmin/Organization.vue'),
      meta: {
        auth: true,
        title: 'Organization - Edurio'
      }
    },
    {
      path: '/admin/survey-tags/:id',
      name: 'survey-admin-add-tags',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey/addtags.vue'),
      meta: {
        auth: true,
        title: 'Survey tags - Edurio'
      }
    },
    {
      path: '/admin/manage-languages',
      name: 'language-table',
      component: () => import(/* webpackChunkName: "language-table" */ '../components/language-table.vue'),
      meta: {
        auth: true,
        title: 'Manage languages - Edurio'
      }
    },
    {
      path: '/admin/manage-translations/:id',
      name: 'translations-list',
      component: () => import(/* webpackChunkName: "translations-list" */ '../components/translations-list.vue'),
      meta: {
        auth: true,
        title: 'Manage translations - Edurio'
      }
    },
    {
      path: '/survey/survey-results-public-urls',
      name: 'survey-results-public-urls',
      component: () => import(/* webpackChunkName: "survey-results-public-urls" */ '../components/survey-results-public-urls.vue'),
      meta: {
        auth: true,
        title: 'Public Results - Edurio'
      }
    },
    {
      path: '/survey/survey/:id',
      name: 'super-admin-survey-period',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey-period/survey-period.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/fiscal-years/:org_id',
      name: 'fiscal-years-list',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/fiscal-years-list.vue'),
      meta: {
        auth: true,
        title: 'School years - Edurio'
      }
    },
    {
      path: '/admin/fiscal-years-edit/:fiscal_year_id',
      name: 'fiscal-years-edit-list',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/fiscal-years-edit-list.vue'),
      meta: {
        auth: true,
        title: 'Fiscal years - Edurio'
      }
    },
    {
      path: '/admin/linked-school-periods/:survey_period_id',
      name: 'linked-school-periods-list',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/linked-school-periods-list.vue'),
      meta: {
        auth: true,
        title: 'Linked school periods - Edurio'
      }
    },
    {
      path: '/admin/imports/wizard',
      name: 'import-wizard',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/import-wizard/import-wizard-home.vue'),
      meta: {
        auth: true,
        title: 'Import Wizard - Edurio'
      }
    },
    {
      path: '/pdfv2/:action',
      name: 'pdf',
      component: () => import(/* webpackChunkName: "pdf" */ '../pages/Pdf.vue')
    },
    {
      path: '/admin/custom-links',
      name: 'super-admin-custom-links',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/custom-links.vue'),
      meta: {
        auth: true,
        title: 'Custom links - Edurio'
      }
    },
    {
      path: '/admin/survey-periods-management',
      name: 'super-admin-survey-periods-management',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey-periods-management.vue'),
      meta: {
        auth: true,
        title: 'Survey period properties management - Edurio'
      }
    },
    {
      path: '/admin/period-props/:period_id',
      name: 'super-admin-period-props',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/period-props/Index.vue'),
      meta: {
        auth: true,
        title: 'Survey period properties management - Edurio'
      }
    },
    {
      path: '/admin/all-emails',
      name: 'super-admin-all-emails',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/all-emails.vue'),
      meta: {
        auth: true,
        title: 'All emails - Edurio'
      }
    },
    {
      path: '/admin/survey-packages',
      name: 'survey-packages-admin',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey-packages/list.vue'),
      meta: {
        auth: true,
        title: 'Survey packages - Edurio'
      }
    },
    {
      path: '/admin/survey-packages/add',
      name: 'survey-packages-admin-add',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey-packages/add.vue'),
      meta: {
        auth: true,
        title: 'Add new survey package - Edurio'
      }
    },
    {
      path: '/admin/survey-packages/:id',
      name: 'survey-packages-admin-edit',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/survey-packages/add.vue'),
      meta: {
        auth: true,
        title: 'Survey package - Edurio'
      }
    },
    {
      path: '/admin/dashboards-manager/:id',
      name: 'dashboards-admin-edit',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/dashboards-admin/edit.vue'),
      meta: {
        auth: true,
        title: 'Dashboard - Edurio'
      }
    },
    {
      path: '/admin/organization/:id/results-usage',
      name: 'results-usage',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/results-usage.vue'),
      meta: {
        auth: true,
        title: 'Results usage - Edurio'
      }
    },
    {
      path: '/admin/properties-generation/:period',
      name: 'properties-generation',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/properties-generation.vue'),
      meta: {
        auth: true,
        title: 'Properties generation - Edurio'
      }
    },
    {
      path: '/admin/wordcloud-management',
      name: 'wordcloud-admin',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/wordcloud/index.vue'),
      meta: {
        auth: true,
        title: 'Wordcloud management - Edurio'
      }
    },
    {
      path: '/admin/bucket-file',
      name: 'super-admin-bucket-file',
      component: () => import(/* webpackChunkName: "SuperAdmin" */ '../components/superadmin/bucket-file.vue'),
      meta: {
        auth: true,
        title: 'Bucket file - Edurio'
      }
    },
    {
			path: '/about-school',
			name: 'about-school',
    },
		{
			path: '/pasvaldibam',
			name: 'pasvaldibam',
    },
    {
			path: '/pirmsskolam',
			name: 'pirmsskolam',
    },
    {
      path: '/tokenized',
      name: 'tokenized',
      component: () => import(/* webpackChunkName: "tokenized" */ '../pages/Tokenized.vue')
    },
    {
      path: '/urlexpired',
      name: 'urlexpired',
      component: () => import(/* webpackChunkName: "urlexpired" */ '../pages/URLExpired.vue')
    },
    {
      path: '/mailedurlexpired',
      name: 'mailedurlexpired',
      component: () => import(/* webpackChunkName: "urlexpired" */ '../pages/URLExpired.vue')
    },
    // always last in routes
    {
      path: '/:org_name',
      name: 'organization-page',
      component: () => import(/* webpackChunkName: "organization-page" */ '../components/code-login/login.vue')
    },
    {
      path: '/auth/invite/:token',
      name: 'Email Invitation',
      component: () => import(/* webpackChunkName: "Logout" */ '../components/invitation.vue'),
    },
  ]
});

// Check if the current user has permissions to view the page if not redirect to dashboard.
router.checkPermissions = function(to){
  let template = new RegExp('("' + to.meta.permissions.join('":true|"') + '":true)', 'gi');
  let hasPermissions = JSON.stringify(router.app.$root.user.permissions).match(template);
  return hasPermissions !== null;
  // #3108 This was removed because this forbids OR perms and for AND there is no meta.perms with more than 2 items.
  // && hasPermissions.length == to.meta.permissions.length
};

router.checkForbiddenProducts = function(to){
  return !to.meta.forbiddenProducts.some(product => router.app.$root.perm('list.' + product));
};

const waitUntilLoaded = (isLoaded) => new Promise((resolve, reject) => {
  const poll = () => {
    setTimeout(() => {
      if (router.app != null && isLoaded()) {
        resolve()
      } else {
        poll()
      }
    }, 100)
  }
  poll()

  setTimeout(reject, 5000)
});

router.beforeEach((to, from, next) => {
    events.trackSuperadminRedirects(to.fullPath);

    const isMissingBenchmarkIdInNewUrl = typeof from.query.benchmarkId !== "undefined" && typeof to.query.benchmarkId === "undefined";
    const goingToSamePath = to.path === from.path;

    if (isMissingBenchmarkIdInNewUrl && goingToSamePath) {
        router.app.$router.push({ query: {...to.query, benchmarkId: from.query.benchmarkId} } );
    }

  if(to.meta.auth != null && to.meta.auth == true) {
    if(localStorage.getItem("token") != null) {
      const hasPermissionGuard = typeof to.meta.permissions !== 'undefined' && to.meta.permissions != null;
      const hasProductGuard = Array.isArray(to.meta.forbiddenProducts) && to.meta.forbiddenProducts.length > 0;

      if (hasPermissionGuard || hasProductGuard) {
        const guards = [];

        if (hasPermissionGuard) {
          guards.push(
            waitUntilLoaded(() => router.app.$root.user.loaded).then(() => router.checkPermissions(to))
          );
        }

        if (hasProductGuard) {
          guards.push(
            waitUntilLoaded(() => router.app.$root.perm('list')).then(() => router.checkForbiddenProducts(to))
          );
        }

        Promise.all(guards).then((isAllowed) => {
          if(isAllowed.every(Boolean)){
            next();
          } else {
            window.location.href = '/dashboard#forbidden'
          }
        }).catch(() => {
          window.location.href = '/dashboard#forbidden'
        })
      } else {
        next();
      }
    } else {
      window.location.href = "/users/login";
    }
  } else {
    next();
  }
});

export default router;
